/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import { RoleFieldsFragmentDoc, DisableEnableUserFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthUserFieldsFragment = { __typename?: 'UserModel', account_id: string, cognito_id?: string | null, created_at: string, updated_at: string, is_deleted?: boolean | null, vitall_user_id?: number | null, created_user_id?: string | null, email?: string | null, first_name: string, last_login?: string | null, last_name: string, profile_picture?: string | null, status: Types.UserStatus, title?: string | null, user_id: string, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }>, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, created_at?: string | null, updated_at?: string | null, is_deleted?: boolean | null, allow_emergency_access: boolean } | null };

export type LoginMutationVariables = Types.Exact<{
  input: Types.LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'AuthModel', id?: string | null, access?: string | null, valid?: boolean | null, challenge?: { __typename?: 'AuthChallenge', name: string, parameters?: Record<string, any> | null } | null, user?: { __typename?: 'UserModel', account_id: string, cognito_id?: string | null, created_at: string, updated_at: string, is_deleted?: boolean | null, vitall_user_id?: number | null, created_user_id?: string | null, email?: string | null, first_name: string, last_login?: string | null, last_name: string, profile_picture?: string | null, status: Types.UserStatus, title?: string | null, user_id: string, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }>, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, created_at?: string | null, updated_at?: string | null, is_deleted?: boolean | null, allow_emergency_access: boolean } | null } | null } | null };

export type RespondToAuthChallengeMutationVariables = Types.Exact<{
  input: Types.RespondToAuthChallengeInput;
}>;


export type RespondToAuthChallengeMutation = { __typename?: 'Mutation', respondToAuthChallenge: { __typename?: 'AuthModel', id?: string | null, access?: string | null, valid?: boolean | null, challenge?: { __typename?: 'AuthChallenge', name: string, parameters?: Record<string, any> | null } | null, user?: { __typename?: 'UserModel', account_id: string, cognito_id?: string | null, created_at: string, updated_at: string, is_deleted?: boolean | null, vitall_user_id?: number | null, created_user_id?: string | null, email?: string | null, first_name: string, last_login?: string | null, last_name: string, profile_picture?: string | null, status: Types.UserStatus, title?: string | null, user_id: string, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }>, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, created_at?: string | null, updated_at?: string | null, is_deleted?: boolean | null, allow_emergency_access: boolean } | null } | null } };

export type ExchangeHandoffTokenMutationVariables = Types.Exact<{
  input: Types.ExchangeHandoffTokenInput;
}>;


export type ExchangeHandoffTokenMutation = { __typename?: 'Mutation', exchangeHandoffToken: { __typename?: 'AuthModel', id?: string | null, access?: string | null, valid?: boolean | null, challenge?: { __typename?: 'AuthChallenge', name: string, parameters?: Record<string, any> | null } | null, user?: { __typename?: 'UserModel', account_id: string, cognito_id?: string | null, created_at: string, updated_at: string, is_deleted?: boolean | null, vitall_user_id?: number | null, created_user_id?: string | null, email?: string | null, first_name: string, last_login?: string | null, last_name: string, profile_picture?: string | null, status: Types.UserStatus, title?: string | null, user_id: string, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }>, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, created_at?: string | null, updated_at?: string | null, is_deleted?: boolean | null, allow_emergency_access: boolean } | null } | null } };

export type LogoutMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponseModel', message: string } };

export type RefreshTokenMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'RefreshModel', id: string, access: string, user_id: string } };

export type ForgotPasswordMutationVariables = Types.Exact<{
  input: Types.EmailInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ChangePasswordModel', message: string } };

export type ChangePasswordMutationVariables = Types.Exact<{
  input: Types.ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'ChangePasswordModel', message: string } };

export type ConfirmPasswordMutationVariables = Types.Exact<{
  input: Types.ConfirmPasswordInput;
}>;


export type ConfirmPasswordMutation = { __typename?: 'Mutation', confirmPassword: { __typename?: 'ChangePasswordModel', message: string } };

export type ChangeUserEmailMutationVariables = Types.Exact<{
  input: Types.ChangeEmailInput;
}>;


export type ChangeUserEmailMutation = { __typename?: 'Mutation', changeUserEmail: { __typename?: 'UpdateUserAttributesResponse', CodeDeliveryDetailsList?: Array<{ __typename?: 'CodeDeliveryDetailsType', Destination?: string | null, DeliveryMedium?: string | null, AttributeName?: string | null }> | null } };

export type VerifyUserEmailMutationVariables = Types.Exact<{
  input: Types.VerifyEmailInput;
}>;


export type VerifyUserEmailMutation = { __typename?: 'Mutation', verifyUserEmail: string };

export type AdminChangeEmailMutationVariables = Types.Exact<{
  input: Types.AdminChangeEmailInput;
}>;


export type AdminChangeEmailMutation = { __typename?: 'Mutation', adminChangeEmail: { __typename?: 'UserModel', user_id: string, email?: string | null } };

export type ResetUserPasswordMutationVariables = Types.Exact<{
  input: Types.EmailInput;
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetUserPassword: boolean };

export type DisableUserMutationVariables = Types.Exact<{
  input: Types.EmailInput;
}>;


export type DisableUserMutation = { __typename?: 'Mutation', disableUser: { __typename?: 'UserModel', user_id: string, disabled: boolean, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, status_id?: string | null, status?: { __typename?: 'StatusModel', color?: string | null, private_name: string, public_name: string, status_id: string } | null } | null } };

export type EnableUserMutationVariables = Types.Exact<{
  input: Types.EmailInput;
}>;


export type EnableUserMutation = { __typename?: 'Mutation', enableUser: { __typename?: 'UserModel', user_id: string, disabled: boolean, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, status_id?: string | null, status?: { __typename?: 'StatusModel', color?: string | null, private_name: string, public_name: string, status_id: string } | null } | null } };

export type ResendSetupInvitationMutationVariables = Types.Exact<{
  input: Types.EmailInput;
}>;


export type ResendSetupInvitationMutation = { __typename?: 'Mutation', resendSetupInvitation: boolean };

export type GetUserDisabledQueryVariables = Types.Exact<{
  input: Types.GetUserInput;
}>;


export type GetUserDisabledQuery = { __typename?: 'Query', getUserSettings: { __typename?: 'UserSettings', user_id: string, disabled?: boolean | null } };

export type SendTotpMfaCodeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SendTotpMfaCodeMutation = { __typename?: 'Mutation', sendTotpMfaCode: { __typename?: 'EnableMFAResponseModel', code: string } };

export type SendSmsMfaCodeMutationVariables = Types.Exact<{
  input: Types.SendSmsMfaCodeInput;
}>;


export type SendSmsMfaCodeMutation = { __typename?: 'Mutation', sendSmsMfaCode: { __typename?: 'MfaResponseModel', message: string } };

export type EnableMfaMutationVariables = Types.Exact<{
  input: Types.EnableMfaInput;
}>;


export type EnableMfaMutation = { __typename?: 'Mutation', enableMfa: { __typename?: 'CompleteMfaResponseModel', message: string, user: { __typename?: 'UserModel', user_id: string, mfa?: { __typename?: 'UserMfaSettingsModel', status: Types.MfaMethod, phone_number?: string | null, phoneVerified: boolean, smsEnabled: boolean, totpEnabled: boolean, emailEnabled: boolean } | null } } };

export type DisableMfaMutationVariables = Types.Exact<{
  input: Types.DisableMfaInput;
}>;


export type DisableMfaMutation = { __typename?: 'Mutation', disableMfa: { __typename?: 'CompleteMfaResponseModel', message: string, user: { __typename?: 'UserModel', user_id: string, mfa?: { __typename?: 'UserMfaSettingsModel', status: Types.MfaMethod, phone_number?: string | null, phoneVerified: boolean, smsEnabled: boolean, totpEnabled: boolean, emailEnabled: boolean } | null } } };

export type SendEmailVerificationCodeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SendEmailVerificationCodeMutation = { __typename?: 'Mutation', sendEmailVerificationCode: { __typename?: 'MfaResponseModel', message: string } };

export type SetPreferredMfaMethodMutationVariables = Types.Exact<{
  input: Types.SetPreferredMfaInput;
}>;


export type SetPreferredMfaMethodMutation = { __typename?: 'Mutation', setPreferredMfaMethod: { __typename?: 'MfaResponseModel', message: string } };

export type ChangeUserPhoneMutationVariables = Types.Exact<{
  input: Types.ChangePhoneInput;
}>;


export type ChangeUserPhoneMutation = { __typename?: 'Mutation', changeUserPhone: { __typename?: 'UpdateUserAttributesResponse', CodeDeliveryDetailsList?: Array<{ __typename?: 'CodeDeliveryDetailsType', Destination?: string | null, DeliveryMedium?: string | null, AttributeName?: string | null }> | null } };

export type AdminChangePhoneMutationVariables = Types.Exact<{
  input: Types.AdminChangePhoneInput;
}>;


export type AdminChangePhoneMutation = { __typename?: 'Mutation', adminChangePhone: { __typename?: 'UserModel', user_id: string } };

export type VerifyUserPhoneMutationVariables = Types.Exact<{
  input: Types.VerifyPhoneInput;
}>;


export type VerifyUserPhoneMutation = { __typename?: 'Mutation', verifyUserPhone: string };

export const AuthUserFieldsFragmentDoc = gql`
    fragment AuthUserFields on UserModel {
  account_id
  cognito_id
  created_at
  updated_at
  is_deleted
  vitall_user_id
  created_user_id
  email
  first_name
  is_deleted
  last_login
  last_name
  profile_picture
  roles {
    ...RoleFields
  }
  status
  title
  updated_at
  user_id
  vitall_user_id
  vitall_patient {
    vitall_patient_id
    patient_id
    created_at
    updated_at
    is_deleted
    allow_emergency_access
  }
}
    ${RoleFieldsFragmentDoc}`;
export const LoginDocument = gql`
    mutation login($input: LoginInput!) {
  login(input: $input) {
    id
    access
    valid
    challenge {
      name
      parameters
    }
    user {
      ...AuthUserFields
    }
  }
}
    ${AuthUserFieldsFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RespondToAuthChallengeDocument = gql`
    mutation respondToAuthChallenge($input: RespondToAuthChallengeInput!) {
  respondToAuthChallenge(input: $input) {
    id
    access
    valid
    challenge {
      name
      parameters
    }
    user {
      ...AuthUserFields
    }
  }
}
    ${AuthUserFieldsFragmentDoc}`;
export type RespondToAuthChallengeMutationFn = Apollo.MutationFunction<RespondToAuthChallengeMutation, RespondToAuthChallengeMutationVariables>;
export function useRespondToAuthChallengeMutation(baseOptions?: Apollo.MutationHookOptions<RespondToAuthChallengeMutation, RespondToAuthChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToAuthChallengeMutation, RespondToAuthChallengeMutationVariables>(RespondToAuthChallengeDocument, options);
      }
export type RespondToAuthChallengeMutationHookResult = ReturnType<typeof useRespondToAuthChallengeMutation>;
export type RespondToAuthChallengeMutationResult = Apollo.MutationResult<RespondToAuthChallengeMutation>;
export type RespondToAuthChallengeMutationOptions = Apollo.BaseMutationOptions<RespondToAuthChallengeMutation, RespondToAuthChallengeMutationVariables>;
export const ExchangeHandoffTokenDocument = gql`
    mutation exchangeHandoffToken($input: ExchangeHandoffTokenInput!) {
  exchangeHandoffToken(input: $input) {
    id
    access
    valid
    challenge {
      name
      parameters
    }
    user {
      ...AuthUserFields
    }
  }
}
    ${AuthUserFieldsFragmentDoc}`;
export type ExchangeHandoffTokenMutationFn = Apollo.MutationFunction<ExchangeHandoffTokenMutation, ExchangeHandoffTokenMutationVariables>;
export function useExchangeHandoffTokenMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeHandoffTokenMutation, ExchangeHandoffTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeHandoffTokenMutation, ExchangeHandoffTokenMutationVariables>(ExchangeHandoffTokenDocument, options);
      }
export type ExchangeHandoffTokenMutationHookResult = ReturnType<typeof useExchangeHandoffTokenMutation>;
export type ExchangeHandoffTokenMutationResult = Apollo.MutationResult<ExchangeHandoffTokenMutation>;
export type ExchangeHandoffTokenMutationOptions = Apollo.BaseMutationOptions<ExchangeHandoffTokenMutation, ExchangeHandoffTokenMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    message
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken {
  refreshToken {
    id
    access
    user_id
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($input: EmailInput!) {
  forgotPassword(input: $input) {
    message
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    message
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ConfirmPasswordDocument = gql`
    mutation confirmPassword($input: ConfirmPasswordInput!) {
  confirmPassword(input: $input) {
    message
  }
}
    `;
export type ConfirmPasswordMutationFn = Apollo.MutationFunction<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>;
export function useConfirmPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>(ConfirmPasswordDocument, options);
      }
export type ConfirmPasswordMutationHookResult = ReturnType<typeof useConfirmPasswordMutation>;
export type ConfirmPasswordMutationResult = Apollo.MutationResult<ConfirmPasswordMutation>;
export type ConfirmPasswordMutationOptions = Apollo.BaseMutationOptions<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>;
export const ChangeUserEmailDocument = gql`
    mutation changeUserEmail($input: ChangeEmailInput!) {
  changeUserEmail(input: $input) {
    CodeDeliveryDetailsList {
      Destination
      DeliveryMedium
      AttributeName
    }
  }
}
    `;
export type ChangeUserEmailMutationFn = Apollo.MutationFunction<ChangeUserEmailMutation, ChangeUserEmailMutationVariables>;
export function useChangeUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserEmailMutation, ChangeUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserEmailMutation, ChangeUserEmailMutationVariables>(ChangeUserEmailDocument, options);
      }
export type ChangeUserEmailMutationHookResult = ReturnType<typeof useChangeUserEmailMutation>;
export type ChangeUserEmailMutationResult = Apollo.MutationResult<ChangeUserEmailMutation>;
export type ChangeUserEmailMutationOptions = Apollo.BaseMutationOptions<ChangeUserEmailMutation, ChangeUserEmailMutationVariables>;
export const VerifyUserEmailDocument = gql`
    mutation verifyUserEmail($input: VerifyEmailInput!) {
  verifyUserEmail(input: $input)
}
    `;
export type VerifyUserEmailMutationFn = Apollo.MutationFunction<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>;
export function useVerifyUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>(VerifyUserEmailDocument, options);
      }
export type VerifyUserEmailMutationHookResult = ReturnType<typeof useVerifyUserEmailMutation>;
export type VerifyUserEmailMutationResult = Apollo.MutationResult<VerifyUserEmailMutation>;
export type VerifyUserEmailMutationOptions = Apollo.BaseMutationOptions<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>;
export const AdminChangeEmailDocument = gql`
    mutation adminChangeEmail($input: AdminChangeEmailInput!) {
  adminChangeEmail(input: $input) {
    user_id
    email
  }
}
    `;
export type AdminChangeEmailMutationFn = Apollo.MutationFunction<AdminChangeEmailMutation, AdminChangeEmailMutationVariables>;
export function useAdminChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<AdminChangeEmailMutation, AdminChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminChangeEmailMutation, AdminChangeEmailMutationVariables>(AdminChangeEmailDocument, options);
      }
export type AdminChangeEmailMutationHookResult = ReturnType<typeof useAdminChangeEmailMutation>;
export type AdminChangeEmailMutationResult = Apollo.MutationResult<AdminChangeEmailMutation>;
export type AdminChangeEmailMutationOptions = Apollo.BaseMutationOptions<AdminChangeEmailMutation, AdminChangeEmailMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation resetUserPassword($input: EmailInput!) {
  resetUserPassword(input: $input)
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const DisableUserDocument = gql`
    mutation disableUser($input: EmailInput!) {
  disableUser(input: $input) {
    ...DisableEnableUserFields
  }
}
    ${DisableEnableUserFieldsFragmentDoc}`;
export type DisableUserMutationFn = Apollo.MutationFunction<DisableUserMutation, DisableUserMutationVariables>;
export function useDisableUserMutation(baseOptions?: Apollo.MutationHookOptions<DisableUserMutation, DisableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableUserMutation, DisableUserMutationVariables>(DisableUserDocument, options);
      }
export type DisableUserMutationHookResult = ReturnType<typeof useDisableUserMutation>;
export type DisableUserMutationResult = Apollo.MutationResult<DisableUserMutation>;
export type DisableUserMutationOptions = Apollo.BaseMutationOptions<DisableUserMutation, DisableUserMutationVariables>;
export const EnableUserDocument = gql`
    mutation enableUser($input: EmailInput!) {
  enableUser(input: $input) {
    ...DisableEnableUserFields
  }
}
    ${DisableEnableUserFieldsFragmentDoc}`;
export type EnableUserMutationFn = Apollo.MutationFunction<EnableUserMutation, EnableUserMutationVariables>;
export function useEnableUserMutation(baseOptions?: Apollo.MutationHookOptions<EnableUserMutation, EnableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableUserMutation, EnableUserMutationVariables>(EnableUserDocument, options);
      }
export type EnableUserMutationHookResult = ReturnType<typeof useEnableUserMutation>;
export type EnableUserMutationResult = Apollo.MutationResult<EnableUserMutation>;
export type EnableUserMutationOptions = Apollo.BaseMutationOptions<EnableUserMutation, EnableUserMutationVariables>;
export const ResendSetupInvitationDocument = gql`
    mutation resendSetupInvitation($input: EmailInput!) {
  resendSetupInvitation(input: $input)
}
    `;
export type ResendSetupInvitationMutationFn = Apollo.MutationFunction<ResendSetupInvitationMutation, ResendSetupInvitationMutationVariables>;
export function useResendSetupInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendSetupInvitationMutation, ResendSetupInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendSetupInvitationMutation, ResendSetupInvitationMutationVariables>(ResendSetupInvitationDocument, options);
      }
export type ResendSetupInvitationMutationHookResult = ReturnType<typeof useResendSetupInvitationMutation>;
export type ResendSetupInvitationMutationResult = Apollo.MutationResult<ResendSetupInvitationMutation>;
export type ResendSetupInvitationMutationOptions = Apollo.BaseMutationOptions<ResendSetupInvitationMutation, ResendSetupInvitationMutationVariables>;
export const GetUserDisabledDocument = gql`
    query getUserDisabled($input: GetUserInput!) {
  getUserSettings(input: $input) {
    user_id
    disabled
  }
}
    `;
export function useGetUserDisabledQuery(baseOptions: Apollo.QueryHookOptions<GetUserDisabledQuery, GetUserDisabledQueryVariables> & ({ variables: GetUserDisabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDisabledQuery, GetUserDisabledQueryVariables>(GetUserDisabledDocument, options);
      }
export function useGetUserDisabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDisabledQuery, GetUserDisabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDisabledQuery, GetUserDisabledQueryVariables>(GetUserDisabledDocument, options);
        }
// @ts-ignore
export function useGetUserDisabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDisabledQuery, GetUserDisabledQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDisabledQuery, GetUserDisabledQueryVariables>;
export function useGetUserDisabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDisabledQuery, GetUserDisabledQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDisabledQuery | undefined, GetUserDisabledQueryVariables>;
export function useGetUserDisabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDisabledQuery, GetUserDisabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDisabledQuery, GetUserDisabledQueryVariables>(GetUserDisabledDocument, options);
        }
export type GetUserDisabledQueryHookResult = ReturnType<typeof useGetUserDisabledQuery>;
export type GetUserDisabledLazyQueryHookResult = ReturnType<typeof useGetUserDisabledLazyQuery>;
export type GetUserDisabledSuspenseQueryHookResult = ReturnType<typeof useGetUserDisabledSuspenseQuery>;
export type GetUserDisabledQueryResult = Apollo.QueryResult<GetUserDisabledQuery, GetUserDisabledQueryVariables>;
export const SendTotpMfaCodeDocument = gql`
    mutation sendTotpMfaCode {
  sendTotpMfaCode {
    code
  }
}
    `;
export type SendTotpMfaCodeMutationFn = Apollo.MutationFunction<SendTotpMfaCodeMutation, SendTotpMfaCodeMutationVariables>;
export function useSendTotpMfaCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendTotpMfaCodeMutation, SendTotpMfaCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTotpMfaCodeMutation, SendTotpMfaCodeMutationVariables>(SendTotpMfaCodeDocument, options);
      }
export type SendTotpMfaCodeMutationHookResult = ReturnType<typeof useSendTotpMfaCodeMutation>;
export type SendTotpMfaCodeMutationResult = Apollo.MutationResult<SendTotpMfaCodeMutation>;
export type SendTotpMfaCodeMutationOptions = Apollo.BaseMutationOptions<SendTotpMfaCodeMutation, SendTotpMfaCodeMutationVariables>;
export const SendSmsMfaCodeDocument = gql`
    mutation sendSmsMfaCode($input: SendSmsMfaCodeInput!) {
  sendSmsMfaCode(input: $input) {
    message
  }
}
    `;
export type SendSmsMfaCodeMutationFn = Apollo.MutationFunction<SendSmsMfaCodeMutation, SendSmsMfaCodeMutationVariables>;
export function useSendSmsMfaCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendSmsMfaCodeMutation, SendSmsMfaCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSmsMfaCodeMutation, SendSmsMfaCodeMutationVariables>(SendSmsMfaCodeDocument, options);
      }
export type SendSmsMfaCodeMutationHookResult = ReturnType<typeof useSendSmsMfaCodeMutation>;
export type SendSmsMfaCodeMutationResult = Apollo.MutationResult<SendSmsMfaCodeMutation>;
export type SendSmsMfaCodeMutationOptions = Apollo.BaseMutationOptions<SendSmsMfaCodeMutation, SendSmsMfaCodeMutationVariables>;
export const EnableMfaDocument = gql`
    mutation enableMfa($input: EnableMfaInput!) {
  enableMfa(input: $input) {
    message
    user {
      user_id
      mfa {
        status
        phone_number
        phoneVerified
        smsEnabled
        totpEnabled
        emailEnabled
      }
    }
  }
}
    `;
export type EnableMfaMutationFn = Apollo.MutationFunction<EnableMfaMutation, EnableMfaMutationVariables>;
export function useEnableMfaMutation(baseOptions?: Apollo.MutationHookOptions<EnableMfaMutation, EnableMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableMfaMutation, EnableMfaMutationVariables>(EnableMfaDocument, options);
      }
export type EnableMfaMutationHookResult = ReturnType<typeof useEnableMfaMutation>;
export type EnableMfaMutationResult = Apollo.MutationResult<EnableMfaMutation>;
export type EnableMfaMutationOptions = Apollo.BaseMutationOptions<EnableMfaMutation, EnableMfaMutationVariables>;
export const DisableMfaDocument = gql`
    mutation disableMfa($input: DisableMfaInput!) {
  disableMfa(input: $input) {
    message
    user {
      user_id
      mfa {
        status
        phone_number
        phoneVerified
        smsEnabled
        totpEnabled
        emailEnabled
      }
    }
  }
}
    `;
export type DisableMfaMutationFn = Apollo.MutationFunction<DisableMfaMutation, DisableMfaMutationVariables>;
export function useDisableMfaMutation(baseOptions?: Apollo.MutationHookOptions<DisableMfaMutation, DisableMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableMfaMutation, DisableMfaMutationVariables>(DisableMfaDocument, options);
      }
export type DisableMfaMutationHookResult = ReturnType<typeof useDisableMfaMutation>;
export type DisableMfaMutationResult = Apollo.MutationResult<DisableMfaMutation>;
export type DisableMfaMutationOptions = Apollo.BaseMutationOptions<DisableMfaMutation, DisableMfaMutationVariables>;
export const SendEmailVerificationCodeDocument = gql`
    mutation sendEmailVerificationCode {
  sendEmailVerificationCode {
    message
  }
}
    `;
export type SendEmailVerificationCodeMutationFn = Apollo.MutationFunction<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>;
export function useSendEmailVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>(SendEmailVerificationCodeDocument, options);
      }
export type SendEmailVerificationCodeMutationHookResult = ReturnType<typeof useSendEmailVerificationCodeMutation>;
export type SendEmailVerificationCodeMutationResult = Apollo.MutationResult<SendEmailVerificationCodeMutation>;
export type SendEmailVerificationCodeMutationOptions = Apollo.BaseMutationOptions<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>;
export const SetPreferredMfaMethodDocument = gql`
    mutation setPreferredMfaMethod($input: SetPreferredMfaInput!) {
  setPreferredMfaMethod(input: $input) {
    message
  }
}
    `;
export type SetPreferredMfaMethodMutationFn = Apollo.MutationFunction<SetPreferredMfaMethodMutation, SetPreferredMfaMethodMutationVariables>;
export function useSetPreferredMfaMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetPreferredMfaMethodMutation, SetPreferredMfaMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPreferredMfaMethodMutation, SetPreferredMfaMethodMutationVariables>(SetPreferredMfaMethodDocument, options);
      }
export type SetPreferredMfaMethodMutationHookResult = ReturnType<typeof useSetPreferredMfaMethodMutation>;
export type SetPreferredMfaMethodMutationResult = Apollo.MutationResult<SetPreferredMfaMethodMutation>;
export type SetPreferredMfaMethodMutationOptions = Apollo.BaseMutationOptions<SetPreferredMfaMethodMutation, SetPreferredMfaMethodMutationVariables>;
export const ChangeUserPhoneDocument = gql`
    mutation changeUserPhone($input: ChangePhoneInput!) {
  changeUserPhone(input: $input) {
    CodeDeliveryDetailsList {
      Destination
      DeliveryMedium
      AttributeName
    }
  }
}
    `;
export type ChangeUserPhoneMutationFn = Apollo.MutationFunction<ChangeUserPhoneMutation, ChangeUserPhoneMutationVariables>;
export function useChangeUserPhoneMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserPhoneMutation, ChangeUserPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserPhoneMutation, ChangeUserPhoneMutationVariables>(ChangeUserPhoneDocument, options);
      }
export type ChangeUserPhoneMutationHookResult = ReturnType<typeof useChangeUserPhoneMutation>;
export type ChangeUserPhoneMutationResult = Apollo.MutationResult<ChangeUserPhoneMutation>;
export type ChangeUserPhoneMutationOptions = Apollo.BaseMutationOptions<ChangeUserPhoneMutation, ChangeUserPhoneMutationVariables>;
export const AdminChangePhoneDocument = gql`
    mutation adminChangePhone($input: AdminChangePhoneInput!) {
  adminChangePhone(input: $input) {
    user_id
  }
}
    `;
export type AdminChangePhoneMutationFn = Apollo.MutationFunction<AdminChangePhoneMutation, AdminChangePhoneMutationVariables>;
export function useAdminChangePhoneMutation(baseOptions?: Apollo.MutationHookOptions<AdminChangePhoneMutation, AdminChangePhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminChangePhoneMutation, AdminChangePhoneMutationVariables>(AdminChangePhoneDocument, options);
      }
export type AdminChangePhoneMutationHookResult = ReturnType<typeof useAdminChangePhoneMutation>;
export type AdminChangePhoneMutationResult = Apollo.MutationResult<AdminChangePhoneMutation>;
export type AdminChangePhoneMutationOptions = Apollo.BaseMutationOptions<AdminChangePhoneMutation, AdminChangePhoneMutationVariables>;
export const VerifyUserPhoneDocument = gql`
    mutation verifyUserPhone($input: VerifyPhoneInput!) {
  verifyUserPhone(input: $input)
}
    `;
export type VerifyUserPhoneMutationFn = Apollo.MutationFunction<VerifyUserPhoneMutation, VerifyUserPhoneMutationVariables>;
export function useVerifyUserPhoneMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserPhoneMutation, VerifyUserPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserPhoneMutation, VerifyUserPhoneMutationVariables>(VerifyUserPhoneDocument, options);
      }
export type VerifyUserPhoneMutationHookResult = ReturnType<typeof useVerifyUserPhoneMutation>;
export type VerifyUserPhoneMutationResult = Apollo.MutationResult<VerifyUserPhoneMutation>;
export type VerifyUserPhoneMutationOptions = Apollo.BaseMutationOptions<VerifyUserPhoneMutation, VerifyUserPhoneMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetUserDisabled = withQueryResponseHandler(useGetUserDisabledQuery);
export const useLogin = withMutationResponseHandler(useLoginMutation, "login");
export const useRespondToAuthChallenge = withMutationResponseHandler(useRespondToAuthChallengeMutation, "respondToAuthChallenge");
export const useExchangeHandoffToken = withMutationResponseHandler(useExchangeHandoffTokenMutation, "exchangeHandoffToken");
export const useLogout = withMutationResponseHandler(useLogoutMutation, "logout");
export const useRefreshToken = withMutationResponseHandler(useRefreshTokenMutation, "refreshToken");
export const useForgotPassword = withMutationResponseHandler(useForgotPasswordMutation, "forgotPassword");
export const useChangePassword = withMutationResponseHandler(useChangePasswordMutation, "changePassword");
export const useConfirmPassword = withMutationResponseHandler(useConfirmPasswordMutation, "confirmPassword");
export const useChangeUserEmail = withMutationResponseHandler(useChangeUserEmailMutation, "changeUserEmail");
export const useVerifyUserEmail = withMutationResponseHandler(useVerifyUserEmailMutation, "verifyUserEmail");
export const useAdminChangeEmail = withMutationResponseHandler(useAdminChangeEmailMutation, "adminChangeEmail");
export const useResetUserPassword = withMutationResponseHandler(useResetUserPasswordMutation, "resetUserPassword");
export const useDisableUser = withMutationResponseHandler(useDisableUserMutation, "disableUser");
export const useEnableUser = withMutationResponseHandler(useEnableUserMutation, "enableUser");
export const useResendSetupInvitation = withMutationResponseHandler(useResendSetupInvitationMutation, "resendSetupInvitation");
export const useSendTotpMfaCode = withMutationResponseHandler(useSendTotpMfaCodeMutation, "sendTotpMfaCode");
export const useSendSmsMfaCode = withMutationResponseHandler(useSendSmsMfaCodeMutation, "sendSmsMfaCode");
export const useEnableMfa = withMutationResponseHandler(useEnableMfaMutation, "enableMfa");
export const useDisableMfa = withMutationResponseHandler(useDisableMfaMutation, "disableMfa");
export const useSendEmailVerificationCode = withMutationResponseHandler(useSendEmailVerificationCodeMutation, "sendEmailVerificationCode");
export const useSetPreferredMfaMethod = withMutationResponseHandler(useSetPreferredMfaMethodMutation, "setPreferredMfaMethod");
export const useChangeUserPhone = withMutationResponseHandler(useChangeUserPhoneMutation, "changeUserPhone");
export const useAdminChangePhone = withMutationResponseHandler(useAdminChangePhoneMutation, "adminChangePhone");
export const useVerifyUserPhone = withMutationResponseHandler(useVerifyUserPhoneMutation, "verifyUserPhone");